import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vue-content-placeholders-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (n) => {
      return (_openBlock(), _createElementBlock("div", {
        key: n,
        class: "vue-content-placeholders-text__line"
      }))
    }), 128))
  ]))
}